module.exports = "<ng-container *ngFor=\"let note of notes\">\n    <nym-note-info [note]=\"note\"></nym-note-info>\n</ng-container>\n"